// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bbu_a bhf_kb","ListItemIcon--empty":"bbu_b bhf_fj"};